import React from "react";
import { useTranslation } from "react-i18next";

function VideoSection() {
  const [t] = useTranslation("global");

  return (
    <section className="bg-gradient-to-br from-gray-50 to-gray-200 py-16 px-5 mt-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h6 className="text-gray-500 font-semibold tracking-widest text-sm mb-2">
            {t("video.subtitle")}
          </h6>
          <h3 className="text-gray-800 font-bold text-3xl mb-4">
            {t("video.title")}
          </h3>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            {t("video.desc")}
          </p>
        </div>
        <div className="relative pb-[56.25%] h-0 overflow-hidden max-w-3xl mx-auto rounded-xl shadow-2xl">
          <iframe
            className="absolute top-0 left-0 w-full h-full border-none rounded-xl"
            src="https://www.youtube.com/embed/MEzpkxlvmQ0"
            title={t("video.title")}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default VideoSection;
